import { useContext, useEffect, useState } from 'react';

import { FeatureFlagState } from '/types';

import { AppShellContext } from './contexts';

const useFeatureFlag = (featureFlagKey: string): FeatureFlagState => {
  const { featureFlags } = useContext(AppShellContext);
  const [flag, setFlag] = useState(FeatureFlagState.LOADING);

  useEffect(() => {
    featureFlags?.getValue(featureFlagKey).then((val) => {
      if (val) {
        setFlag(FeatureFlagState.TRUE);
      } else {
        setFlag(FeatureFlagState.FALSE);
      }
    });
  }, [featureFlagKey, featureFlags]);

  return flag;
};

export default useFeatureFlag;
